<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper -->
<div class="flex w-full flex-auto flex-col" *transloco="let t">
    <!-- Content -->
    <div class="flex flex-auto flex-col text-base">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <!-- Cookie Preferences Button -->
            <button
                [matTooltip]="t('cookieConsent.btn-tooltip')"
                (click)="openCookieConsent()"
                matTooltipPosition="left"
                type="button"
                mat-mini-fab
                color="primary"
                class="fixed bottom-4 right-4 z-50 shadow-lg hover:shadow-xl">
            <svg height="30" viewBox="0 0 20 20" width="30" xmlns="http://www.w3.org/2000/svg"><path d="m10 2c.6449 0 1.2727.07642 1.8744.22092.1772.04256.3173.17815.3655.3539s-.003.36381-.1337.49083c-.3745.364-.6062.87167-.6062 1.43435 0 .95322.6673 1.75176 1.5608 1.95173.2556.05721.4392.28426.4392.54827 0 1.10457.8954 2 2 2 .5989 0 1.1358-.26262 1.5031-.68064.1266-.14407.3244-.20305.5092-.1518.1848.05124.324.20367.3583.39236.0851.4675.1294.94883.1294 1.44008 0 4.4183-3.5817 8-8 8-4.41828 0-8-3.5817-8-8 0-4.41828 3.58172-8 8-8zm0 1c-3.86599 0-7 3.13401-7 7 0 3.866 3.13401 7 7 7 3.866 0 7-3.134 7-7 0-.13266-.0037-.26442-.011-.39519-.4387.25129-.9472.39519-1.489.39519-1.5434 0-2.8146-1.16549-2.9815-2.66437-1.1747-.40661-2.0185-1.52208-2.0185-2.83563 0-.5243.1347-1.01745.3711-1.44637-.2852-.03539-.5759-.05363-.8711-.05363zm2 10c.5523 0 1 .4477 1 1s-.4477 1-1 1-1-.4477-1-1 .4477-1 1-1zm-5-1c.55228 0 1 .4477 1 1s-.44772 1-1 1-1-.4477-1-1 .44772-1 1-1zm3-3c.5523 0 1 .44772 1 1 0 .5523-.4477 1-1 1-.55228 0-1-.4477-1-1 0-.55228.44772-1 1-1zm-4-2c.55228 0 1 .44772 1 1s-.44772 1-1 1-1-.44772-1-1 .44772-1 1-1z"/></svg>
            </button>
            <router-outlet></router-outlet>
        }
    </div>
</div>
